import * as _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import * as bookActions from '../../../actions/bookActions';
import { MODES } from '../AssignmentsContentPanel/assignmentsContentPanelService';
import { GROUPS as CONSTS } from '../../../const';
import AssignmentsContentPanel from '../AssignmentsContentPanel/AssignmentsContentPanel';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as readAssignementsContentPanelService from './readAssignmentsContentPanelService';
import * as lessonListContainerService from '../LessonListContainer/lessonListContainerService';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import * as taskActions from '../../../actions/taskActions';

const PANELS = {
  CREATE_ASSIGNMENT: 'CREATE_ASSIGNMENT',
  INDIVIDUAL_SELECTION: 'INDIVIDUAL_SELECTION'
};

export class EditAssignmentsContentPanel extends Component {
  static propTypes = {
    task: PropTypes.object,
    groups: PropTypes.array,
    activities: PropTypes.array,
    description: PropTypes.string,
    title: PropTypes.string,
    dueDate: PropTypes.any,
    startDate: PropTypes.any,
    allowFile: PropTypes.bool,
    classroom: PropTypes.object,
    skinColors: PropTypes.object,
    isAppOnline: PropTypes.bool,
    bookActions: PropTypes.object,
    selectedGroup: PropTypes.object,
    classroomGroupActions: PropTypes.object,
    assignmentsDrawerActions: PropTypes.object,
    taskActions: PropTypes.object,
    checkedActivities: PropTypes.array
  };

  constructor(context, props) {
    super(context, props);
    this.getSelectedGroup = this.getSelectedGroup.bind(this);
    this.updateAllActivitiesChecks = this.updateAllActivitiesChecks.bind(this);
    this.state = {
      panel: PANELS.CREATE_ASSIGNMENT,
      currentSelection: {},
      lessons: {},
      isAllChecked: false,
      datesContainerState: {
        currentDate: dayjs(), // value used to validate if task dates are right,
        hasInteraction: false
      }
    };
  }

  resetActivitiesStateIfEmpty = currentTask => {
    const { assignmentsDrawerActions, bookActions } = this.props;
    const hasActivities = currentTask && Array.isArray(currentTask.activities) && currentTask.activities.length;

    if (!hasActivities) {
      assignmentsDrawerActions.onCheckedActivitiesChange([]);
    }
  };

  setDatesContainerInteraction = hasInteraction => {
    const { datesContainerState } = this.state;
    this.setState(Object.assign({ datesContainerState }, { hasInteraction }));
  };

  componentDidMount() {
    const {
      task,
      classroom,
      classroomGroupActions,
      bookActions,
      selectedGroup,
      assignmentsDrawerActions,
      taskActions
    } = this.props;

    if (task) {
      if (task.bookId) {
        taskActions.setTaskContentsNotFound(false);
        bookActions.getBookActivities(classroom.id, task.bookId);
        bookActions.getBookInfo();
      }
      classroomGroupActions.getClassroomGroups(classroom.id);
      assignmentsDrawerActions.setDescriptionTask(task.wording);
      assignmentsDrawerActions.setTitleTask(task.name);
      assignmentsDrawerActions.setAllowFile(task.allowFileResponse);
      assignmentsDrawerActions.setAllowUserCommentResponse(task.allowUserCommentResponse);
      assignmentsDrawerActions.setStartDate(task.startDate);
      assignmentsDrawerActions.setDueDate(task.dueDate);
      this.resetActivitiesStateIfEmpty(task);
    }
    this.setState({
      currentSelection: selectedGroup
    });
  }

  componentDidUpdate(prevProps) {
    const { task, activities } = this.props;

    if (activities !== prevProps.activities) {
      let selected = _.map(task.activities, act => act.activityId);
      let lessons = lessonListContainerService.getLessonsAndActivities(activities, selected);
      this.setState({
        lessons,
        isAllChecked: this.areAllChecked(lessons)
      });
    }

    if (task && (!prevProps.task || task.id !== prevProps.task.id)) {
      this.resetActivitiesStateIfEmpty(task);
    }
  }

  componentWillUnmount() {
    const { bookActions, assignmentsDrawerActions, taskActions, checkedActivities } = this.props;

    taskActions.setTaskContentsNotFound(false);
    bookActions.setActivities();
    assignmentsDrawerActions.setSelectedGroup(CONSTS.EVERYONE);
    assignmentsDrawerActions.setStartDate();
    assignmentsDrawerActions.setDueDate();
    assignmentsDrawerActions.onCheckedActivitiesChange(checkedActivities);
    assignmentsDrawerActions.setDescriptionTask();
    assignmentsDrawerActions.setTitleTask();
    assignmentsDrawerActions.setAllowFile();
  }

  areAllChecked = lessons => {
    let notChecked = _.findKey(lessons, { checked: false });
    return !notChecked;
  };

  updateAllActivitiesChecks = () => {
    const { lessons, isAllChecked } = this.state;
    const { assignmentsDrawerActions } = this.props;

    Object.values(lessons).forEach(lesson => {
      lesson.checked = !isAllChecked;
      Object.values(lesson.activities).forEach(activity => {
        activity.checked = !isAllChecked;
      });
    });

    this.setState({ lessons: lessons, isAllChecked: !isAllChecked });
    assignmentsDrawerActions.onCheckedActivitiesChange(lessonListContainerService.getActivitiesChecked(lessons));
  };

  getSelectedGroup = () => {
    const { groups, task } = this.props;

    let result;
    let group = task.sections && task.sections.length ? _.first(task.sections) : undefined;
    let student = task.users && task.users.length === 1 ? _.first(task.users) : undefined;

    if (group) {
      result = readAssignementsContentPanelService.getGroupWithId(group.id, groups);
    } else if (student) {
      result = readAssignementsContentPanelService.getStudent(student._id);
    }
    return result;
  };

  getTask = () => {
    const {
      allowUserCommentResponse,
      allowExpiredResponse,
      groups,
      activities,
      task,
      classroom,
      dueDate,
      startDate,
      description,
      title,
      allowFile,
      checkedActivities
    } = this.props;

    return {
      id: task.id,
      title: title,
      dueDate: dayjs(dueDate ? dueDate : task.dueDate),
      startDate: dayjs(startDate ? startDate : task.startDate),
      selectedGroup: this.getSelectedGroup(),
      groups: groups,
      activities: activities,
      checkedActivities: checkedActivities,
      description: description,
      classroomId: classroom.id,
      allowFile: allowFile,
      allowUserCommentResponse: allowUserCommentResponse,
      allowExpiredResponse: task.allowExpiredResponse,
      students: task.users,
      files: task.files
    };
  };

  setLessons = lessons => {
    this.setState({ lessons });
  };

  setAllChecked = isAllChecked => {
    this.setState({ isAllChecked });
  };

  render() {
    const { isAppOnline, skinColors, task } = this.props;
    const { lessons, isAllChecked } = this.state;

    const mode = isAppOnline ? MODES.EDIT : MODES.READ;

    return (
      <AssignmentsContentPanel
        setDatesContainerInteraction={this.setDatesContainerInteraction}
        datesContainerState={this.state.datesContainerState}
        lessons={lessons}
        isAllChecked={isAllChecked}
        updateAllActivitiesChecks={this.updateAllActivitiesChecks}
        task={this.getTask()}
        mode={mode}
        colors={skinColors}
        setAllChecked={this.setAllChecked}
        setLessons={this.setLessons}
        //se envía a null porque en mode = edit/read no se muestra el panel de selección de usuarios
        filteredUsers={null}
        isAboutContent={task.bookId ? true : false}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    groups: state.classrooms.selectedClassroom.groups,
    startDate: state.assignmentsDrawerActions.startDate,
    dueDate: state.assignmentsDrawerActions.dueDate,
    activities: state.assignmentsDrawerActions.activities,
    checkedActivities: state.assignmentsDrawerActions.checkedActivities,
    description: state.assignmentsDrawerActions.descriptionTask,
    title: state.assignmentsDrawerActions.titleTask,
    allowFile: state.assignmentsDrawerActions.allowFile,
    allowUserCommentResponse: state.assignmentsDrawerActions.allowUserCommentResponse,
    task: state.task.selectedTask,
    isAppOnline: state.connection.status.online,
    skinColors: state.theme.colors,
    classroom: state.classrooms.selectedClassroom.classroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditAssignmentsContentPanel);
